function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import _ from 'lodash';
import { stateNamePrefix as AddBuildingSubWizard } from '../AddBuildingWizard/RouteConfig';

var EditBuildingCtrl = function EditBuildingCtrl($rootScope, $scope, $state, ViewModelService, ModalService, CPCoverablesService, $filter, StateUtils, cpDeleteBuildingService) {
    var _this = this;

    _classCallCheck(this, EditBuildingCtrl);

    var buildingDTOName = 'edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.BuildingDTO';
    this.model = StateUtils.activeDataForState(true).model;
    this.jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;
    this.sessionId = SessionUtil.getSessionUUID(this.model);
    this.showChangesWarning = true;

    $scope.location = _.find(this.model.lobData.commercialProperty.coverables.locations.value, function (location) {
        return location.publicID === $state.params.building.locationId;
    });

    $scope.building = _.find($scope.location.buildings, function (building) {
        return building.publicID === $state.params.building.publicID;
    });

    $scope.buildingVM = ViewModelService.create(_.clone($scope.building), 'pc', buildingDTOName);

    var cancelWarning = function cancelWarning() {
        return ModalService.showWarning('quoteandbind.cp.buildingsWizard.EditBuilding.Cancel Changes?', 'quoteandbind.cp.buildingsWizard.EditBuilding.You will lose all the changes', undefined, undefined, undefined, $filter('translate')('quoteandbind.cp.No'));
    };

    $scope.back = function (buildingUpdated) {
        if (!buildingUpdated && !_.isEqual($scope.building, $scope.buildingVM.value)) {
            cancelWarning().result.then(function () {
                handleBack(buildingUpdated);
            });
        } else {
            handleBack(buildingUpdated);
        }
    };

    var handleBack = function handleBack(buildingUpdated) {
        _this.showChangesWarning = false;
        var params = {
            publicID: $scope.building.publicID,
            isBuildingUpdated: Boolean(buildingUpdated),
            isCoverageOpen: false
        };

        $state.go('cpBuildingWizardViewBuilding', params);
    };

    $scope.deleteBuilding = function () {
        cpDeleteBuildingService.deleteBuilding(_this.model, $scope.location, $scope.building).then(function () {
            return $state.go('cpBuildingWizardBuildingsList');
        }).catch(function () {
            return ModalService.showError('quoteandbind.cp.directives.cp-building-view.Building not removed', 'quoteandbind.cp.views.cp-building-view.Please check for errors and try again');
        });
    };

    $scope.updateBuilding = function () {
        $scope.buildingInfo.newBuildingForm.submitted = true;
        if ($scope.buildingInfo.newBuildingForm.invalid) {
            return;
        }

        // No need to send the update request is nothing has changed
        if (_.isEqual($scope.building, $scope.buildingVM.value)) {
            $scope.back(true);
        } else {
            updateBuilding().then(function () {
                $scope.back(true);
            }).catch(function () {
                ModalService.showError('quoteandbind.cp.directives.cp-building-directive.Building not saved', 'quoteandbind.cp.Please check for errors and try again');
            });
        }
    };

    $scope.cancel = function () {
        if (_.isEqual($scope.building, $scope.buildingVM.value)) {
            handleBack();
        } else {
            cancelWarning().result.then(function () {
                handleBack();
            });
        }
    };

    $scope.toEditLocation = function () {
        $state.go('cpBuildingWizardEditLocation', { publicID: $scope.location.publicID, buildingPublicID: $scope.building.publicID });
    };

    var updateBuilding = function updateBuilding() {
        _this.updateBuildingPromise = CPCoverablesService.updateCPBuilding(_this.jobID, $scope.location.publicID, $scope.buildingVM.value, _this.sessionId);

        return _this.updateBuildingPromise.then(function (building) {

            var buildingIndex = _.findIndex($scope.location.buildings, function (blding) {
                return blding.publicID === building.publicID;
            });

            $scope.location.buildings.splice(buildingIndex, 1, building);
        });
    };

    var stateChangeUnsub = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
        if (_this.showChangesWarning && !_.isEqual($scope.building, $scope.buildingVM.value) && (StateUtils.hasState('baseTransactionWizard', toState) || StateUtils.hasState(AddBuildingSubWizard, toState))) {

            event.preventDefault();

            ModalService.showWarning('quoteandbind.cp.Unsaved Changes', 'quoteandbind.cp.Do you want to save your changes?', undefined, undefined, undefined, $filter('translate')('quoteandbind.cp.No')).result.then(function () {
                // Update the building - this will then transition
                updateBuilding().then(function () {
                    $state.go(toState, toParams);
                });
            }).catch(function () {
                // If the user chooses to discard, go to state
                $state.go(toState, toParams);
            });
        }
        stateChangeUnsub(); // Unsubscribe $stateChangeStart listener
    });
};

EditBuildingCtrl.$inject = ['$rootScope', '$scope', '$state', 'ViewModelService', 'ModalService', 'qnb.cpCoverablesService', '$filter', 'StateUtils', 'qnb.cpDeleteBuildingService'];

export default EditBuildingCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/EditBuilding/EditBuildingCtrl.js
// module id = 988
// module chunks = 0